import React from 'react';
import {Button, Col, Layout, Row, Space} from "antd";
import {useNavigate} from "react-router-dom";
import {LogoutOutlined} from "@ant-design/icons";
import {useMutation, useQueryClient} from "@tanstack/react-query";
import {logoutAPI} from "../../api/AuthAPI";
import SessionTimer from './SessionTimer';
import axios from "axios";

const AppHeader = () => {
    const { Header } = Layout;
    const navigate = useNavigate();
    const expiryTime = parseInt(sessionStorage.getItem('exp'));
    const queryClient = useQueryClient();

    const onClickLogout = () => {
        logoutMutation.mutate();
    }

    const logoutMutation = useMutation(() => logoutAPI(), {
        onSuccess: () => {
            navigate('/', {replace: true});
            queryClient.clear();
            sessionStorage.clear();
        },
        onError: () => {
            sessionStorage.clear();
            queryClient.clear();
            delete axios.defaults.headers['X-AUTH-TOKEN'];
            navigate('/', {replace: true});
        }
    })

    return (
        <Header style={{backgroundColor: 'white'}}>
            <Row justify='end'>
                <Space size='large'>
                    <Col>
                        <SessionTimer expiryTimestamp={expiryTime} />
                    </Col>
                    <Col>
                        <Button shape='round' onClick={onClickLogout} icon={<LogoutOutlined />}>로그아웃</Button>
                    </Col>
                </Space>
            </Row>
        </Header>
    );
};

export default AppHeader;